<template>
  <div class="fst-container">
    <h1>FSTP项目</h1>
    <div class="subtitle">EE快速通道</div>
    
    <div class="content">
      <h2>基本要求：</h2>
      <ul>
        <li>
          <strong>工作经验：</strong>过去5年至少有2年全职或相关part-time NOC TEER 2 or 3技工岗位工作经验(可以不连续)
        </li>
        <li>
          <strong>语言：</strong>听说达CLB 5，读写写CLB 4
        </li>
        <li>
          <strong>工作证明：</strong>需要有工作邀请（LMIA）或加拿大政府颁发的技工证书
        </li>
        <li>
          <strong>资金要求：</strong>½ MNI的安置资金(如果没有工作邀请)
        </li>
        <li>
          <strong>居住地：</strong>居住在Quebec以外的其它省份或地区
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FSTView'
}
</script>

<style scoped>
.fst-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

h2 {
  font-size: 24px;
  color: #333;
  margin: 30px 0 20px;
}

.content {
  font-size: 16px;
  line-height: 1.8;
  color: #444;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 20px;
  padding-left: 20px;
  position: relative;
}

li:before {
  content: '•';
  position: absolute;
  left: 0;
  color: #666;
}

strong {
  color: #333;
}
</style>